<template>
    <div v-if="Jdetail.detail" class="us-jrn-all-contaier">
        <div v-html="Jdetail['detail'].title" class="us-journey-title"></div>
        <div v-html="Jdetail['detail'].subtitle" class="us-journey-subtitle"></div>

        <div class="us-journey-pic-slider" v-if="Jdetail.images.length > 0">
            <swiper :options="swiperOptionTop" class="gallery-top" ref="swiperTop" style="width:100%;height:80%;">
                <swiper-slide class="slide_Top" v-for="(jPic, a) in Jdetail.images" :key="a">
                    <div class="us-journey-pic-img" v-bind:style="{ 'background-image': 'url(' + jPic.link.replace(/\/web\//gi, '/xxl/') + ')' }">
                        <div class="us-journey-pic-copyright">{{ jPic.picture.copyright }}</div>
                    </div>
                </swiper-slide>
                <div class="swiper-button-next" slot="button-next"></div>
                <div class="swiper-button-prev" slot="button-prev"></div>
            </swiper>

            <swiper :options="swiperOptionThumbs" class="gallery-thumbs" ref="swiperThumbs" style="width:100%;height:20%;">
                <swiper-slide class="slide_Thumb" v-for="(jPic, b) in Jdetail.images" :key="b">
                    <div class="us-journey-pic-img-thumb" v-bind:style="{ 'background-image': 'url(' + jPic.link + ')' }"></div>
                    <div class="us-journey-pic-copyright">{{ jPic.picture.copyright }}</div>
                </swiper-slide>
            </swiper>
        </div>
        <div v-html="Jdetail['detail'].einleitung" class="us-journey-descption"></div>
        <div v-html="Jdetail['detail'].hotelbeschreibung" class="us-journey-descption"></div>
        <div v-if="Jdetail['days'].length > 0" class="us-journey-descption">
            <div v-for="(day, daykey) in Jdetail['days']" :key="daykey">
                <h4 v-html="day.title"></h4>
                <p v-html="day.text"></p>
            </div>
        </div>
        <div v-else v-html="Jdetail['detail'].reisebeschreibung" class="us-journey-descption"></div>

        <div><br /><b>Leistungen:</b></div>
        <div v-html="Jdetail['detail'].leistungen" class="us-journey-leistungen"></div>

        <div v-if="Jdetail['detail'].hinweise !== '' && Jdetail['detail'].hinweise !== null" style="padding-top: 30px;"><b>Hinweise</b></div>
        <div v-html="Jdetail['detail'].hinweise" class="us-journey-descption"></div>

        <el-row class="us-termin-headline">
            <el-col :span="4">Reisebeginn</el-col>
            <el-col :span="4">Reiseende</el-col>
            <el-col :span="6">&nbsp;</el-col>
            <el-col :span="4" style="text-align: center;">Status</el-col>
            <el-col :span="4" style="text-align: right;">Preis</el-col>
        </el-row>
        <el-row v-for="(date, key) in kuschickDates" :key="key" style="padding: 10px 0px;">
            <!-- <el-col :span="24">
                <pre>{{ date }}</pre>
            </el-col> -->
            <el-col :span="4">{{ formatDate(date.TerminVon) }}</el-col>
            <el-col :span="4">{{ formatDate(date.TerminBis) }}</el-col>
            <el-col :span="6" style="text-align: center;"><el-button size="mini" type="info" @click="bookJourney(date)">Reise buchen</el-button></el-col>
            <el-col :span="4" style="text-align: center;"><fai size="2x" :icon="getReiseStatus(date.ReiseStatusHin).icon" :style="getReiseStatus(date.ReiseStatusHin).style"></fai></el-col>
            <el-col :span="4" style="text-align: right;">{{ date.abPreis }} EUR</el-col>
        </el-row>

        <el-dialog :visible.sync="showframe" custom-class="kuschick-dialog" @close="showframe = false" append-to-body>
            <iframe v-if="showframe" :src="framesrc" frameborder="0" style="width: 100%;height: 50vh;"></iframe>
        </el-dialog>
        <br /><br />
    </div>
</template>

<script>
export default {
    mounted() {
        this.setJourneys()
    },
    data() {
        return {
            kuschickDates: [],
            showframe: false,
            framesrc: "",
            Jdetail: {},
            swiperOptionTop: {
                spaceBetween: 5,
                loop: true,
                loopedSlides: 4, //looped slides should be the same
                navigation: {
                    nextEl: ".swiper-button-next",
                    prevEl: ".swiper-button-prev"
                }
            },
            swiperOptionThumbs: {
                spaceBetween: 5,
                slidesPerView: 4,
                touchRatio: 0.2,
                loop: true,
                loopedSlides: 4, //looped slides should be the same
                slideToClickedSlide: true
            }
        }
    },
    watch: {
        $route(to, from) {
            this.setJourneys()
        }
    },
    methods: {
        setJourneys() {
            let args = core.getPathArgs(["id"])
            core.backend("jrn.getJourneyWeb", { id_jrn_journey: args.id }, (err, res) => {
                this.Jdetail = JSON.parse(JSON.stringify(res.data))

                this.Jdetail.days = this.Jdetail.days.map(day => {
                    day.title = day.title.replace(/\n/g, "<br>")
                    day.text = day.text.replace(/\n/g, "<br>")
                    return day
                })
console.log("this.Jdetail", this.Jdetail);
                this.Jdetail.detail.leistungen = "<li>" + JSON.parse(JSON.stringify(this.Jdetail.detail.leistungen.replace(/\n/g, "</li><li>")))

                this.$nextTick(() => {
                    if(this.Jdetail.images.length > 0) {
                        const swiperTop = this.$refs.swiperTop.swiper
                        const swiperThumbs = this.$refs.swiperThumbs.swiper
                        swiperTop.controller.control = swiperThumbs
                        swiperThumbs.controller.control = swiperTop
                    }

                    core.kuschick("getDates", { kuschick_id: res.data.kuschick_id }, (kerr, kres) => {
                        console.log("kres", kres);
                        this.kuschickDates = kres
                    })
                })
            })
        },

        formatDate(date) {
            return new Intl.DateTimeFormat("de-DE", { year: "numeric", month: "2-digit", day: "2-digit" }).format(new Date(date))
        },
        getReiseStatus(stat) {
            switch (stat) {
                case "A":
                    return { icon: "times-square", style: { color: "red" } }
                case "F":
                    return { icon: "check-square", style: { color: "green" } }
                default:
                    return { icon: "minus-square", style: { color: "orange" } }
            }
        },

        bookJourney(date) {
            this.showframe = true
            this.framesrc = `https://kuschick.unisigns.de/lww/buspronet/maske_buchung.php?id=${date.IDReise}`
        }
    }
}
</script>


<style lang="scss" scoped>
.us-termin-headline {
    padding-top: 25px;
    padding-bottom: 5px;
    font-weight: bold;
    border-bottom: 2px solid #cecece;
}

.us-jrn-all-contaier {
    padding-left: 10px;
    padding-right: 10px;
}

.us-journey-pic-slider {
    width: 100%;
    height: 40vw;
    position: relative;
}

.swiper-container {
    background-color: rgb(39, 39, 39);
}

.slide_Top,
.slide_Thumb {
    height: inherit;
    width: inherit;
    position: relative;
}

.us-journey-pic-img {
    width: inherit;
    height: inherit;
    background-size: cover;
    background-position: center;
}

.us-journey-pic-img-thumb {
    width: inherit;
    height: inherit;
    background-size: cover;
    background-position: center;
}
.gallery-thumbs {
    padding-top: 5px;
}

.slide_Thumb.swiper-slide {
    opacity: 0.4;
}
.slide_Thumb.swiper-slide-active {
    opacity: 1;
}

.us-journey-pic-copyright {
    position: absolute;
    z-index: 20;
    bottom: 10px;
    left: 10px;
    color: #fff;
    font-size: 9px;
    text-shadow: 0 1px 5px rgba(0, 0, 0, 0.3), 0 1px 5px rgba(0, 0, 0, 0.3), 0 1px 5px rgba(0, 0, 0, 0.3), 0 1px 5px rgba(0, 0, 0, 0.3);
}
.slide_Thumb .us-journey-pic-copyright {
    bottom: 5px;
}

.us-journey-title {
    font-size: 30px;
}
.us-journey-descption {
    font-size: 16px;
    margin-top: 20px;
    color: #676767;
}
.us-journey-leistungen {
    font-size: 16px;
    margin-top: 20px;
    margin-left: 20px;
    color: #676767;
}

.us-journey-subtitle {
    font-size: 16px;
    margin-bottom: 20px;

    color: #676767;
}

</style>